module.exports = __webpack_public_path__ + "img/comment.6ff6dc7b.svg";